export default __webpack_public_path__ + "alberta-key.3c1bfc3401881fc59d39.svg";